define('lq/frontendModules',['lq'], function (lq) {
    'use strict';

    var getServerTicks = function () {
        return 621356004000000000 + 10000 * Date.now();
    };

    var createScript = function (scriptUrl) {
        var script = document.createElement('script');
        script.async = false; // make sure the script are executed in the correct order
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', scriptUrl);
        return script;
    };

    var createLink = function (linkUrl) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', linkUrl);
        return link;
    };

    var vendorLoaded = false;

    var load = function (bundleName, includeCss) {
        if (!vendorLoaded) {
            var script = createScript(lq.getFrontEndUrl('') + 'vendor.bundle.js?bust=' + getServerTicks());
            document.getElementsByTagName('head')[0].appendChild(script);
            vendorLoaded = true;
        }

        if (includeCss) {
            var link = createLink(lq.getFrontEndUrl('') + bundleName + '.bundle.css?bust=' + getServerTicks());
            document.getElementsByTagName('head')[0].appendChild(link);
        }

        return new Promise((resolve) => {
            if (window[bundleName])
                return resolve(window[bundleName]);

            var script = createScript(lq.getFrontEndUrl('') + bundleName + '.bundle.js?bust=' + getServerTicks());
            script.onload = function () {
                resolve(window[bundleName]);
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    };

    return {
        load: load
    };
});
